import axios from 'axios';
import { apiBaseUrl, mooApiBaseUrl } from '@/config';
import { consoleError } from '@/utils/logger';
import { clearSsoCookieIfOwn } from '@/utils/ssoCookie';

// Token expiré/invalide (401) -> on nettoie la session et on renvoie vers /login.
// Garde anti-boucle : on ne redirige pas si on est déjà sur la page de connexion.
let authRedirecting = false;
const handleAuthError = (error) => {
  if (error.response?.status === 401 && typeof window !== 'undefined') {
    const path = window.location.pathname || '';
    if (!authRedirecting && !path.startsWith('/login') && !path.startsWith('/register')) {
      authRedirecting = true;
      let failingToken = null;
      try {
        const parsed = JSON.parse(localStorage.getItem('user') || 'null');
        failingToken = parsed?.data?.token || parsed?.token || null;
      } catch (e) { /* ignore */ }
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      clearSsoCookieIfOwn(failingToken);
      window.location.href = '/login';
    }
  }
  return Promise.reject(error);
};

// Configuration de base pour axios avec l'URL directe de l'API
const axiosPeelo = axios.create({
  baseURL: apiBaseUrl,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Intercepteur pour ajouter automatiquement le token d'authentification
axiosPeelo.interceptors.request.use(
  (config) => {
    const userData = localStorage.getItem('user');
    if (userData) {
      try {
        const userObj = JSON.parse(userData);
        const token = userObj.data?.token;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
        consoleError('Erreur lors de la lecture du token:', error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les réponses et les erreurs d'authentification
axiosPeelo.interceptors.response.use(
  (response) => response,
  handleAuthError
);

const axiosMoo = axios.create({
  baseURL: mooApiBaseUrl,
  timeout: 600000, // gros builds Moo : on laisse jusqu'à 10 min (le backend rend la main avant)
  headers: {
    'Content-Type': 'application/json'
  }
});

axiosMoo.interceptors.request.use(
  (config) => {
    const userData = localStorage.getItem('user');
    if (userData) {
      try {
        const userObj = JSON.parse(userData);
        const token = userObj.data?.token;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
        consoleError('Erreur lors de la lecture du token Moo:', error);
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosMoo.interceptors.response.use(
  (response) => response,
  handleAuthError
);

export { axiosPeelo, axiosMoo };